export enum PresentationPermissionField {
  IS_EDITABLE = 'is_editable',
  IS_GUEST_EDITABLE = 'is_guest_editable',
  IS_DUPLICATABLE = 'is_duplicatable',
  IS_DELETABLE = 'is_deletable',
  IS_INTERNALLY_SHAREABLE = 'is_internally_shareable',
  IS_PUBLICLY_SHAREABLE = 'is_publicly_shareable',
  CAN_COPY_TO_CLIPBOARD = 'can_copy_to_clipboard'
}
